import { ReceiptENT } from '../../../types/models/receipt/receipt.types';
import { PAYMENT_ENDPOINTS } from '../../../utils/api/endpoints/paymentEndpoints';

const PREFIX = '[allReceiptsQuery]';

export const queryAllReceipts = async () => {
  console.log(PREFIX, `Fetching all user receipts...`);
  const response = await PAYMENT_ENDPOINTS.allReceipts();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all user receipts.`);
  return json as ReceiptENT[];
};
